import React, { useEffect, useState } from "react";
import { AuthProvider, useAuth, hasAuthParams } from "react-oidc-context";
import { useSearchParams } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import { ApplicationPaths } from "Contants";

export function withSession(Component) {
    const Session = (props) => {
        const auth = useAuth();
        const [searchParams, setSearchParams] = useSearchParams();
        const [clientId, setClientId] = useState();
        const [settings, setSettings] = useState();
        const [error, setError] = useState();

        const login = async () => {
            void auth.signinRedirect();
        }

        const logout = async () => {
            void auth.signoutRedirect();
        }

        const readUserSettings = async () => {
            const cipherText = localStorage.getItem('userData');
            let settings = {};

            try {
                if (!cipherText) {
                    var response = await fetch(ApplicationPaths.ApiAuthorizationClientConfigurationUrl + "/settings/" + auth.user.profile.oid + "/" + auth.user.profile.unique_name);

                    let responsejson = await response.json();                    
                    if (!response.ok) {
                        setError(responsejson)
                    }
                    else {
                        storeUserSettings(responsejson.settings, "KC2RzVEW");
                        settings = JSON.parse(responsejson.settings);
                    }
                } else {
                    const cipherText = localStorage.getItem('userData');
                    const bytes = CryptoJS.AES.decrypt(cipherText, "KC2RzVEW");
                    const originalText = bytes.toString(CryptoJS.enc.Utf8);

                    settings = JSON.parse(originalText);
                    if (settings.configuration)
                        settings.configuration = JSON.parse(settings.configuration);
                }

                //remove query params after login as errors on page refresh
                searchParams.delete('code');
                searchParams.delete('state');
                searchParams.delete('session_state');
                setSearchParams(searchParams);

                setSettings(settings);
                setClientId(settings.clientId);
            }
            catch(err)
            {
                console.log(err)
                setError(err)
            }
        };

        const storeUserSettings = (input, secretKey) => {
            const cipherText = CryptoJS.AES.encrypt(input, secretKey).toString();
            localStorage.setItem('userData', cipherText);
        };

        useEffect(() => {
            if (!hasAuthParams() &&
                !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading) {
                auth.signinRedirect();
            }
            if (auth.isAuthenticated && !auth.isLoading)
                readUserSettings();
        }, [auth]);

        return (
            <Component clientId={clientId} settings={settings} login={login} logout={logout} auth={auth} error={error} {...props} />
        );
    };

    return Session;
}


